import anime from "animejs/lib/anime.es.js";
const lib = require("../library");

export default class HeroSlideshow {
    constructor(el) {
        this.el = el;
        this.setVars();
        this.bindEvents();
    }

    setVars() {
        this.slides = this.el.querySelectorAll("[data-slide]");
        this.slideNav = this.el.querySelector("[data-slide-nav]");
        this.navLinks = this.slideNav.querySelectorAll("li");
        this.activeClass = "s-active";
        this.inactiveClass = "s-inactive";
        this.progressClass = "s-animating";
        this.height = lib.getHeight(this.el);
    }

    bindEvents() {
        this.navInit();
        this.handleResize();
        // this.handleSetHeight(this.height);
        this.navLinks.forEach((element) => {
            element.addEventListener("click", this.handleNavClick);
        });
    }

    navInit() {
        const tl = anime.timeline({
            easing: "easeOutQuad",
        });
        tl.add({
            targets: this.slideNav,
            opacity: [0, 1],
            translateY: [10, 0],
            duration: 400,
        });
    }
    handleNavClick = (e) => {
        e.preventDefault();
        const { currentTarget } = e;
        const index = currentTarget.dataset.slideNavIndex;
        const current = this.el.querySelector(
            "[data-slide]" + `.${this.activeClass}`,
        );

        // only do something if index is defined and it's not the current one
        if (typeof index !== undefined && current.dataset.slide !== index) {
            const next = this.el.querySelector(`[data-slide="${index}"]`);
            this.handleSlideSwitch(current, next);
        }
    };

    handleSetHeight(target) {
        this.el.style.height = target + "px";
    }

    handleSlideSwitch(current, next) {
        this.height = lib.getHeight(this.el);
        // this.el.style.height = this.height + "px";

        this.handleSetHeight(this.height);

        const inImage = next.querySelector('[data-slide-part="image"]');
        const inText = next.querySelectorAll('[data-slide-part="text"]');
        const outImage = current.querySelector('[data-slide-part="image"]');
        const outText = current.querySelectorAll('[data-slide-part="text"]');
        const tl = anime.timeline({
            easing: "easeInQuad",
            duration: 150,
        });
        tl.add({
            targets: outImage,
            opacity: [1, 0],
            duration: 200,
            delay: anime.stagger(100),
            begin: () => {
                inImage.style.opacity = 1;
                current.classList.add(this.progressClass);
                next.classList.add(this.progressClass);
                next.classList.remove(this.inactiveClass);
            },
        });
        tl.add({
            targets: outText,
            opacity: [1, 0],
            // translateX: [0, "-5px"],
            delay: anime.stagger(100),
            complete: () => {
                current.classList.remove(this.activeClass);
                current.classList.remove(this.progressClass);
                current.classList.add(this.inactiveClass);
            },
            offset: "-=300",
        });
        tl.add({
            targets: inText,
            opacity: [0, 1],
            // translateX: ["5px", 0],
            easing: "easeOutSine",
            delay: anime.stagger(100),
            begin: () => {
                next.classList.add(this.progressClass);
            },
            complete: () => {
                next.classList.remove(this.progressClass);
                next.classList.add(this.activeClass);
                this.updateNav(next.dataset.slide);
            },
            offset: "-=300",
        });
    }

    handleResize() {
        window.addEventListener("resize", () => {
            this.el.style.height = "";
            this.height = lib.getHeight(this.el);
            this.handleSetHeight(this.height);
        });
    }

    updateNav(currentIndex) {
        this.navLinks.forEach((element) => {
            if (element.dataset.slideNavIndex === currentIndex) {
                element.classList.add(this.activeClass);
            } else {
                element.classList.remove(this.activeClass);
            }
        });
    }
}
